<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 15:11:54
 * @Description: 选择登录方式（未使用）
-->
<template>
	<div class="login_list">
		<NavBar
			:title="$route.meta.title"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<div class="common_list_self">
			<div class="c_l_s_item">
				<div class="c_l_s_left">
					<img class="c_l_s_l_img" src="@/assets/mAssets/images/login/icon_wx.png" />
					<span>微信（已绑定）</span>
				</div>
				<Icon class="c_l_s_right" name="arrow" />
			</div>
			<div class="c_l_s_item">
				<div class="c_l_s_left">
					<img class="c_l_s_l_img" src="@/assets/mAssets/images/login/icon_wx2.png" />
					<span>企业微信（已绑定）</span>
				</div>
				<Icon class="c_l_s_right" name="arrow" />
			</div>
		</div>
	</div>
</template>

<script>
import { NavBar, Icon } from "vant";

export default {
	name: "LoginList",
	components: { NavBar, Icon },
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
</style>
